import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormSelect from 'components/Select';
import Form from 'components/Form';
import Text from 'components/Text';
import ClickCollectPlaceholder from './components/ClickCollectPlaceholder';
import { getText } from 'helpers/i18n';

import './clickCollect.styles.scss';

import imgDeliveryCC from 'images/ws-click-and-collect.svg';

export default class ClickCollect extends Component {
    componentDidMount() {
        const { getCollectionStores, stores } = this.props;

        if (stores.length === 1) {
            getCollectionStores();
        }
    }

    render() {
        const { stores, selectedStore, noProductsAvailable, setSelectedStore, error } = this.props;

        const noStoresAvailable = Object.keys(stores).length === 1;

        if (!window.Checkout.settings.clickcollect.enable_on_shoppinglist) {
            return null;
        }

        if (noStoresAvailable || noProductsAvailable) {
            return <ClickCollectPlaceholder/>;
        }

        return (
            <div className="clickcollect">
                <div className="delivery__option">
                    <img src={imgDeliveryCC} alt=""/>
                    <span className="delivery__option-type">
                        <Text textKey="delivery_options_click_collect"/>
                    </span>
                    {window.Checkout.settings.clickcollect.show_price &&
                        <span className="delivery__option-cost">
                            <Text textKey="clickcollect_price_tag" />
                        </span>
                    }
                </div>
                <Form>
                    <FormSelect
                        options={stores}
                        onChange={setSelectedStore.bind(this)}
                        defaultValue={selectedStore}
                        ariaLabel={getText('clickcollect_select_aria_label')}
                    />
                    {error &&
                        <p className="error-helper"><Text textKey={'clickcollect_error_' + error} /></p>
                    }
                </Form>
            </div>
        );
    }
}

ClickCollect.propTypes = {
    stores: PropTypes.array.isRequired,
    getCollectionStores: PropTypes.func.isRequired,
    setSelectedStore: PropTypes.func.isRequired,
    selectedStore: PropTypes.string.isRequired,
    noProductsAvailable: PropTypes.bool.isRequired,
    error: PropTypes.any,
};
